module.exports = __webpack_public_path__ + "img/baseball.4949fd68.jpeg";